// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1df313f0","453":"75e79555","455":"9bfd7fbd"}[chunkId] + ".chunk.js";
};